import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { renderRichText } from "gatsby-source-contentful/rich-text"

import LightbulbOrange from "@images/knowledge-center/lightbulb-orange.svg"
import LightbulbGreen from "@images/knowledge-center/lightbulb-green.svg"
import LightbulbBlue from "@images/knowledge-center/lightbulb-blue.svg"
import { richTextOptions } from "@utils/knowledge-center"

const ExpertTipContainer = styled.div`
  .tip {
    margin-top: 16px;
  }
`

const ExpertTipTitle = styled.div`
  .header-text {
    overflow: hidden;
    width: 100%;
    text-align: center;
    font-size: 20px;
    line-height: 28px;
    color: ${props => props.categoryColor};

    &:before,
    &:after {
      background-color: #e5eaf1;
      content: "";
      display: inline-block;
      height: 2px;
      position: relative;
      vertical-align: middle;
      width: 50%;
    }

    &:before {
      right: 24px;
      margin-left: -50%;
    }

    &:after {
      left: 24px;
      margin-right: -50%;
    }
  }
`

const LightbulbContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;

  .lightbulb-line {
    width: 100%;
    text-align: center;
    border-bottom: 2px solid #e5eaf1;
    line-height: 16px;
  }

  img + .lightbulb-line {
    margin-top: 0;
  }

  .lightbulb-icon {
    margin-top: 0;
    margin-right: 16px;
    margin-left: 16px;
  }
`

const ArticleExpertTip = props => {
  const LightbulbColor = () => {
    if (props.category === "finances") {
      return LightbulbGreen
    }
    if (props.category === "mortgages") {
      return LightbulbBlue
    }
    if (props.category === "homeownership") {
      return LightbulbOrange
    }
  }

  const CategoryTitleTextColor = () => {
    if (props.category === "finances") {
      return "#077577"
    }
    if (props.category === "mortgages") {
      return "#007AB4"
    }
    if (props.category === "homeownership") {
      return "#BD432B"
    }
  }
  return (
    <ExpertTipContainer
      className="article-expert-tip article-component"
      category={props.category}
    >
      <ExpertTipTitle categoryColor={CategoryTitleTextColor()}>
        <h2 className="header-text">Expert Tip</h2>
      </ExpertTipTitle>

      <div className="tip">
        {renderRichText(props.fields.tip, richTextOptions(props))}
      </div>

      <LightbulbContainer>
        <h3 className="lightbulb-line">{""}</h3>
        <img
          className="lightbulb-icon"
          src={LightbulbColor()}
          alt="light bulb icon"
        />
        <h3 className="lightbulb-line">{""}</h3>
      </LightbulbContainer>
    </ExpertTipContainer>
  )
}

export default ArticleExpertTip
